import { useCallback, useEffect, useState } from 'react';
import { readAiNudgeDismissed, writeAiNudgeDismissed } from './aiNudgeDismissed';

/** Whether this user closed the AI assistants card, and the way to close it. */
export function useAiNudgeDismissed(userId: number | null): { isDismissed: boolean; dismiss: () => void } {
  const [isDismissed, setIsDismissed] = useState(() => userId !== null && readAiNudgeDismissed(userId));

  // Another user signed in on the same page: read the flag of that user.
  useEffect(() => {
    setIsDismissed(userId !== null && readAiNudgeDismissed(userId));
  }, [userId]);

  const dismiss = useCallback(() => {
    if (userId !== null) {
      writeAiNudgeDismissed(userId);
    }
    setIsDismissed(true);
  }, [userId]);

  return { isDismissed, dismiss };
}
